var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:" max-w-5xl mx-auto mt-10"},[_c('osv-account',{attrs:{"widget-options":"showBookingDuration=false"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }